import { Box, Skeleton } from "@mui/material";

import { v4 as uuid } from "uuid";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EDEFEF",
    color: "#1D4A87",
    fontWeight: "700",
    fontSize: 14,
    textAlign: "right",
    marginBottom: "0.5rem",
    overflowX: "auto",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "right !important",
    overflowX: "auto",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ActivePlansTableSkeleton = ({ rowsNum }: { rowsNum: number }) => {
  return (
    <>
      {
        <Table
          sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
          aria-label="customized table"
        >
          <TableHead sx={{ outline: "1px solid #DAE0E4" }}>
            <TableRow>
              <StyledTableCell>کاربر درخواست کننده</StyledTableCell>
              <StyledTableCell align="right">تاریخ درخواست</StyledTableCell>
              <StyledTableCell align="right">کاربر بررسی کننده</StyledTableCell>
              <StyledTableCell align="right">تاریخ بررسی</StyledTableCell>
              <StyledTableCell align="right">وضعیت</StyledTableCell>
              <StyledTableCell align="right">
                مبلغ اعتبار (ریال)
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <Box style={{ height: "0.5rem" }}></Box>

          <TableBody sx={{ outline: "1px solid #DAE0E4" }}>
            {[...Array(rowsNum)].map((supplier) => (
              <StyledTableRow key={uuid()}>
                <StyledTableCell component="th" scope="row">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={30}
                    sx={{ borderRadus: "5px" }}
                  ></Skeleton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      }
    </>
  );
};

export default ActivePlansTableSkeleton;
